<form [formGroup]="form">
  <label>
    <strong class="pr-1">{{ "SERIAL_NUMBER" | translate }}</strong>
    <span [matTooltip]="'ENTER_EVERWATCH_ID' | translate" class="fa fa-fw fa-circle-info"></span>
  </label>
  <input class="form-control" type="text" [placeholder]='"SERIAL_NUMBER" | translate' formControlName="everWatchId" name="serialNumber">

  @if (form.get('lyraId').value) {
    <label class="mt-3"><strong>Lyra ID</strong></label>
    <input class="form-control" type="text" formControlName="lyraId" name="lyraId">
    <div class="mt-3">
      <div class="from-group">
        <label><strong>{{'LOCATION' | translate}}</strong></label>
      </div>
      <mat-form-field appearance="outline">
        <mat-select formControlName="locationId">
          <mat-option [value]="''">{{ 'LOCATION' | translate }}</mat-option>
          @for (location of locations; track location) {
            <mat-option [value]="location.id">
              {{ location.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <label><strong>{{ "NAME" | translate }}</strong></label>
    <input class="form-control" type="text" [placeholder]='"NAME" | translate' formControlName="deviceName" name="name">
  }

  <div class="form-group mt-4">
    @if (!form.get('lyraId').value) {
      <button
        type="button"
        class="btn btn-outline-primary gray-bg mr-1"
        data-testid="verify-button"
        [disabled]="form.get('everWatchId').invalid"
        (click)="verifyId()"
        >
        <i [ngClass]="showSpinner ? 'fas fa-circle-notch fa-spin mr-1' : 'fa-light fa-check'"></i>
        {{ (showSpinner ? "VERIFYING" : "VERIFY") | translate }}
      </button>
    } @else {
      <button
        type="button"
        data-testid="submit-button"
        class="btn btn-primary"
        [disabled]="form.invalid || !form.controls.everWatchId.value || !form.controls.lyraId || showSpinner"
        (click)="submit()"
        >
        <i [ngClass]="showSpinner ? 'fad fa-spinner-third fa-spin mr-2' : 'fa-light fa-floppy-disk mr-1'"></i>
        {{ (showSpinner ? "SAVING" : "SAVE") | translate }}
      </button>
      <button type="button" data-testid="cancel-button" class="btn btn-outline-primary gray-bg ml-3" [disabled]="showSpinner" (click)="clearForm()">
        <i class="fa-light fa-xmark"></i>
        {{ "CLEAR_FORM" | translate }}
      </button>
    }

  </div>
</form>

